import React from "react";
import {ClipLoader} from "react-spinners";
import MyWorkShopFilters from "./Filters";
import SearchField from "./SearchField";
import HttpClient from "services/HttpClient";
import OnlineWorkShop from "./OnlineWorkShop";
import { StickyContainer, Sticky } from "react-sticky";
import Modal from "react-modal";

import {
  GROUP_WORKSHOPS_TYPE,
} from "stores/WorkshopsUrlConstants";
import { inject, observer } from "mobx-react";
import "styles/css/pagination.scss";
import Pagination from "./Pagination";
import _ from "lodash";
import EMPTY from "styles/img/empty_results.svg";
const ONLINE_WORKSHOPS = "/api/v1/workshops/online/?";
const DELETE = "/api/v1/workshops/";

@inject("searchFieldEventEmitter")
@inject("alert", "modal", 'filter', 'user')
@observer
class GroupSupervision extends React.Component {
  state = {
    workshops: [],
    title: "",
    type: null,
    pagesCount: 0,
    defaultPrefix: "PUBLIC WEBINARS",
    modalOpened: false,
    delelteObject: null,
    pathname: '',
    isLoading: false,
    // workshopsUpated: false
  };

  componentWillMount = () => {
    this.initialize(this.props.location.pathname);
    this.onStartFunction();
    this.routerListn();
  };

  onStartFunction = () => {
    this.props.searchFieldEventEmitter.setInitialState();
    this.props.searchFieldEventEmitter.allowRAP();
    // this.initialize(this.props.location.pathname);
  };

  routerListn = () => {
    const myWorkshopPaths = [
      '/group_supervision',
      '/public_webinars',
    ];

    this.routerListener = this.props.history.listen((location, action) => {

      if (location.pathname !== this.state.pathname) {
        if (myWorkshopPaths.indexOf(location.pathname) > -1) {
          this.props.searchFieldEventEmitter.denyRAP();
          this.props.searchFieldEventEmitter.setInitialState();
          this.initialize(location.pathname);
        } else {
          this.props.searchFieldEventEmitter.denyRAP();
          this.props.searchFieldEventEmitter.setInitialState();
        }
      }

    });
  }

  loadNewByUrl = requestUrl => {
    this.setState({isLoading: true});
    let url = requestUrl;
    if (!requestUrl && this.props.location.search) {
      url = this.props.location.search.slice(1);


      // parse url for filter and page params on load
      var urlPage = url.match(/page=\d+/);
      if (urlPage) {
        this.props.searchFieldEventEmitter.denyRAP();
        var page = urlPage[0].slice(5)
        this.props.searchFieldEventEmitter.setPage(page);
        this.props.searchFieldEventEmitter.allowRAP();
      }
    }
    
    if (this.state.type === GROUP_WORKSHOPS_TYPE) {
      const requestUrlPayload = url ? `${url}&workshop_types[]=3` : '&workshop_types[]=3&page=1';
      new HttpClient().get(ONLINE_WORKSHOPS + requestUrlPayload).then(response => {
        // console.log("url from ONLINE_WORKSHOPS", url);
        this.setState({
          workshops: response.body.data.workshops,
          count: response.body.data.count,
          defaultPrefix: "PUBLIC WEBINARS",
          isLoading: false,
        });
        window.scrollTo(0, 0);
        this.props.searchFieldEventEmitter.setTotalPages(
          response.body.data.pages
        );
      });
    }
  };

  initialize = pathName => {
    this.props.searchFieldEventEmitter.allowRAP();
    this.props.searchFieldEventEmitter.handleReset();
    const type = GROUP_WORKSHOPS_TYPE;

    this.setState({
        type: type,
        title: "",
        pathname: pathName
      },
      () => {this.loadNewByUrl("");
    });
  };

  handleChangeTitle = newTitle => {
    this.setState({ title: newTitle });
  };

  componentWillUnmount = () => {
    this.routerListener();
  };

  handleDelete = id => {
    this.setState({ modalOpened: true, delelteObject: id });
  };

  closeIcon = () => {
    this.setState({ title: "" }, () => {
      this.props.searchFieldEventEmitter.activate();
    });
  };

  deleteObject = () => {
    new HttpClient().delete(DELETE + this.state.delelteObject).then(data => {
      let elements = _.assign([], this.state.workshops);
      let index = elements.findIndex(el => el.id === this.state.delelteObject);
      elements.splice(index, 1);
      this.setState({
        workshops: elements,
        deleteObject: null,
        modalOpened: false
      });
      this.props.alert.success("This Workshop has been deleted.");
    });
  };

  decline = () => {
    this.setState({ modalOpened: false, deleteObject: null });
  };

  updateWorkshopFromList =(newWorkshop) => {
    this.setState({
      ...this.state,
      workshops: this.state.workshops.map((workshop) =>
        workshop.id != newWorkshop.id ? workshop : newWorkshop
      )
    })
  }

  render() {
    return (
      <main className="main-content purchased">
        <Modal
          isOpen={this.state.modalOpened}
          closeTimeoutMS={100}
          contentLabel="Modal"
        >
          <h1>Are you sure you want to delete this Workshop?</h1>
          <div className="modal-permissions-button">
            <div className="workshop-creator-sidebar-publish">
              <span className="btn prime bordered" onClick={this.deleteObject}>
                Accept
              </span>
            </div>
            <div
              className="workshop-creator-sidebar-publish"
              style={{ marginLeft: 15 }}
            >
              <span className="btn prime bordered red" onClick={this.decline}>
                Decline
              </span>
            </div>
          </div>
        </Modal>

        <div className="container-fluid workshop-list dashboard">
          <SearchField
            submitFilter={this.loadNewByUrl}
            count={this.state.count}
            value={this.state.title}
            defaultPrefix={this.state.defaultPrefix}
            handleChangeTitle={this.handleChangeTitle}
            closeIcon={this.closeIcon}
          />
          <StickyContainer className="row">
            <div className="col-12 col-md-3">
              {window.innerWidth > 767 ? (
                <Sticky>
                  {({ style }) => (
                    <MyWorkShopFilters
                      submitFilter={this.loadNewByUrl}
                      title={this.state.title}
                      count={this.state.count}
                      defaultPrefix={this.state.defaultPrefix}
                      style={style}
                    />
                  )}
                </Sticky>
              ) : (
                <MyWorkShopFilters
                  submitFilter={this.loadNewByUrl}
                  title={this.state.title}
                  count={this.state.count}
                  defaultPrefix={this.state.defaultPrefix}
                />
              )}
            </div>
            <div className="col-12 col-md-9">
              <div className="section-holder workshop-card-holder">
                <div
                  className="section-holder-inner"
                  style={{ position: "relative", minHeight: 300 }}
                >
                  {this.state.workshops.length === 0 && (
                    <div
                      style={{ position: "absolute", top: "40%", left: "50%" }}
                    >
                      <div
                        style={{
                          backgroundColor: "#ebebeb",
                          width: 64,
                          height: 64,
                          borderRadius: "50%",
                          marginLeft: -32
                        }}
                      >
                        <img
                          src={EMPTY}
                          alt=""
                          style={{ marginLeft: 21.5, marginTop: 22 }}
                        />
                      </div>
                      <p
                        style={{
                          opacity: 0.87,
                          width: 300,
                          marginLeft: -150,
                          fontSize: 20,
                          marginTop: 10,
                          lineHeight: 1.25,
                          textAlign: "center",
                          letterSpacing: 0.1,
                          color: "rgba(0, 0, 0, 0.54)"
                        }}
                      >
                        There are no Workshops matching your chosen criteria.
                      </p>
                    </div>
                  )}

                  {this.state.workshops.map(el => {
                    if (el.workshop_type === "online" || el.workshop_type === "live" || el.workshop_type === 'group_supervision')
                      return (
                        <OnlineWorkShop
                          type={this.state.type}
                          workshop={el}
                          key={el.id}
                          handleDelete={this.handleDelete}
                          isWebinar={el.workshop_type === "live" || el.workshop_type === 'group_supervision'}
                        />
                      );
                  })}
                  {this.state.isLoading && (
                    <div className="spinner-container">
                      <ClipLoader color='#00BFFF' loading={this.state.isLoading} size={150} />
                    </div>
                  )}
                </div>
                {this.state.count ? <Pagination /> : null}
              </div>
            </div>
          </StickyContainer>
        </div>
      </main>
    );
  }
}

export default GroupSupervision;



// WEBPACK FOOTER //
// ./src/components/providers/GroupSupervision.jsx